const $ = jQuery.noConflict();

class ContainerOrder {
    init() {
        
        $('form#container-search').submit(function(event) {
            event.preventDefault();
            
            var zipCode = $('form#container-search input#location').val();
            var wasteType = $('form#container-search select#waste-type').val();

            var date = new Date();
            date.setTime(date.getTime()+(1000*60*60*24));
            var expires = date.toGMTString();
            
            document.cookie = 'wbw_zipcode='+zipCode+';expires='+expires+';path=/;';
            document.cookie = 'wbw_wastetype='+wasteType+';expires='+expires+';path=/;';

            window.location.replace('/compare-dumpsters/');
        });

        $('[data-clear-button]').on('click', function(event) {
            event.preventDefault();

            document.cookie = 'wbw_container=0;Max-Age=-99999999;path=/;';
            document.cookie = 'wbw_zipcode=0;Max-Age=-99999999;path=/;';
            document.cookie = 'wbw_wastetype=0;Max-Age=-99999999;path=/;';
            document.cookie = 'wbw_tier=0;Max-Age=-99999999;path=/;';

            location.reload();
        });

        $('[order-container], .order-container').on('click', function(event) {
            event.preventDefault();

            var date = new Date();
            date.setTime(date.getTime()+(1000*60*60*24));
            var expires = date.toGMTString();
            var containerID = $(this).attr('containerid');

            document.cookie = 'wbw_container='+containerID+';expires='+expires+';path=/;';

            window.location.replace('/order/?js');
        });

        var headerHeight = $('.main-header').outerHeight();
        var stickyHeight = ((headerHeight + 30)+'px');
        $('.container-is-sticky').children().css('top', stickyHeight);
    }
}
export default new ContainerOrder;
